import type { IGradientScroll } from "@/types/library/Misc";
import { cn } from "@/utils/css";
import { useEffect, useRef, useState } from "react";

const GradientScroll: React.FC<IGradientScroll> = ({
  children,
  contentClassName,
  noScrollbar = true,
  noTopGradient = false,
  noBottomGradient = false,
  roundedBottom = false,
}) => {
  const scrollableElement = useRef<HTMLDivElement>(null);
  const contentElement = useRef<HTMLDivElement>(null);
  const [overlayClasses, setOverlayClasses] = useState<string[]>([]);

  useEffect(() => {
    handleScroll();
  }, []);

  const handleScroll = () => {
    if (!scrollableElement.current && !contentElement.current) {
      return;
    }

    const scrollableScrollTop = scrollableElement.current.scrollTop;
    const contentHeight = contentElement.current.clientHeight;
    const atBottom =
      scrollableElement.current.scrollHeight ===
      contentHeight + scrollableScrollTop;
    const classes = [];

    if (scrollableScrollTop === 0 || noTopGradient) {
      classes.push("top");
    }

    if (atBottom || noBottomGradient) {
      classes.push("bottom");
    }

    setOverlayClasses(classes);
  };

  return (
    <div
      className={cn("gradient-scroll", noScrollbar ? "" : "customScrollbar")}
    >
      <div className="gradient-scroll-container">
        <div
          className={cn(
            "scrollable",
            noScrollbar ? "no-scrollbar" : "customScrollbar overflow-x-hidden",
            roundedBottom ? "rounded-b-3xl" : "",
          )}
          onScroll={handleScroll}
          ref={scrollableElement}
        >
          {/* biome-ignore lint/nursery/useSortedClasses: <Disabling the rule to allow .join(" ") to have a gap within the string> */}
          <div className={cn("overlay", overlayClasses.join(" "))} />

          <div className={cn("content", contentClassName)} ref={contentElement}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GradientScroll;
